const wishlistReducer = (state = null, action) => {
    switch (action.type) {
        case 'SET_WISHLIST':
            return [...action.payload]
        case 'REMOVE_WISHLIST':
            return action.payload
        default:
            return state
    }
}

export default wishlistReducer